<template>
  <button @click="backClick" class="btn blue center back-button">
    <font-awesome-icon icon="arrow-left" />
  </button>
</template>

<script>
import router from '../router'
export default {
    name: 'BackButton',
    props: ['onRoute'],
    methods: {
      backClick () {
        if (this.onRoute) {
          this.onRoute()
        } else {
          router.go(-1)
        }
      }
    }
}
</script>

<style scoped>
.back-button {
    height: 30px;
    width: 30px;
    padding: 0;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
}
</style>